import React from 'react'
import { EmergencyWrap } from 'src/components/EmergencySavings/Emergency'
import SEO from 'src/seo'
const EmergencySavings = () => {
  return (
    <div>
      <SEO title="Emergency Savings" />
      <EmergencyWrap />
    </div>
  )
}
export { EmergencySavings }
